import PropTypes from "prop-types";
import { getStatusLabel, getStatusTone } from "./statusFlow";

/* Summary bar: reference, when it was placed, size, value and live status. */
const OrderHeader = ({ orderNumber, placedAt, itemCount, total, shippingMethod, status }) => {
  const meta = [
    placedAt
      ? `Placed ${placedAt.toLocaleDateString(undefined, {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}`
      : null,
    itemCount ? `${itemCount} ${itemCount === 1 ? "item" : "items"}` : null,
    total || null,
    shippingMethod || null,
  ].filter(Boolean);

  return (
    <section className="c4trk__summary">
      <div className="c4trk__summary-main">
        <p className="c4trk__summary-eyebrow">Order</p>
        <h2 className="c4trk__summary-id">{orderNumber}</h2>
        <p className="c4trk__summary-meta">
          {meta.map((entry, index) => (
            <span key={entry}>
              {index > 0 ? <span aria-hidden="true"> · </span> : null}
              {entry}
            </span>
          ))}
        </p>
      </div>

      <span className={`c4trk__badge c4trk__badge--${getStatusTone(status)}`}>
        {getStatusLabel(status)}
      </span>
    </section>
  );
};

OrderHeader.propTypes = {
  orderNumber: PropTypes.string,
  placedAt: PropTypes.instanceOf(Date),
  itemCount: PropTypes.number,
  total: PropTypes.string,
  shippingMethod: PropTypes.string,
  status: PropTypes.string,
};

export default OrderHeader;
